import './DateRangeInput.scss';
import React from 'react';
import DateInput from './DateInput';
import { maxOfDates, minOfDates } from 'services/Dates';

const DateRangeInput = ({
  minDate,
  maxDate,
  toDate,
  fromDate,
  toggleFromDate,
  toggleToDate,
  toggleTimePeriod,
  timePeriodLabel
}) => {
  return (
    <div className="select-group e2e-sort-by-select">
      {toggleTimePeriod && (
        <div className="select-labels">
          <span>Custom Range</span>
          <a onClick={toggleTimePeriod}>{timePeriodLabel}</a>
        </div>
      )}
      <div className="select-dates">
        <DateInput
          minDate={minDate}
          maxDate={minOfDates(maxDate, toDate)}
          onChange={toggleFromDate}
          defaultDate={fromDate}
        />
        <DateInput
          minDate={maxOfDates(minDate, fromDate)}
          maxDate={maxDate}
          onChange={toggleToDate}
          defaultDate={toDate}
        />
      </div>
    </div>
  );
};

export default DateRangeInput;
